import { PhoneOutlined } from "@ant-design/icons";
import { AUTH_CONTACT_NUMBER } from "./constants";

const AuthMobileContact = () => (
  <a
    href={`tel:${AUTH_CONTACT_NUMBER.replace(/\s/g, "")}`}
    className="flex sm:hidden items-center justify-center gap-2 py-3 text-gray-500 text-sm hover:text-gray-700"
  >
    <PhoneOutlined />
    <span>{AUTH_CONTACT_NUMBER}</span>
  </a>
);

export default AuthMobileContact;
